import { BaseApiOutput } from './base-api.model';
import { EncFile } from '../enc-file.model';
import { IServerAddresses } from 'src/sync';
import { FileItem } from '../files.model';

export class PathListApiOutput extends BaseApiOutput {
  public cwd: FileItem;
  public hist_id: number;
  public pathlist: FileItem[];
  public sync_id: number;
  public progress: number;
  public servers: IServerAddresses;
  public servers_web: string[];
  public servers_preview: string[];
  public servers_compat: string[];
  public last_metaname_digest: string;
  public parents: EncFile[];
  public total_favorite: number;
}

export class PathListApiInput {
  public sync_id: number;
  public showdeleted: number;
  public hist_id: number;
  public offset_metaname_digest: string;
  public is_vault: boolean;
}
